
import {
    InspectionArabic,
    InspectionEnglish,
    SylndrPlusEnglish,
    SylndrPlusArabic,
} from 'public/Images';
import Link from '@/components/WrappedLink';
import myImageLoader from '@/image.local.loader';

export const InspectionBanner = ({ lang }: { lang: string }) => {
    return (
        <div className="w-full flex gap-3">
            <div className="w-1/2">
                <Link
                    href={`http://get.sylndr.com/${lang}/sylndr-inspection/`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className="w-full"
                        alt="entry-application-profile "
                        src={myImageLoader({
                            src:
                                lang === 'en'
                                    ? InspectionEnglish.src
                                    : InspectionArabic.src,
                            quality: 100,
                        })}
                    />
                </Link>
            </div>
            <div className="w-1/2">
                <Link
                    href={`https://get.sylndr.com/${lang}/sylndr-plus`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className="w-full"
                        alt="entry-application-profile "
                        src={myImageLoader({
                            src:
                                lang === 'en'
                                    ? SylndrPlusEnglish.src
                                    : SylndrPlusArabic.src,
                            quality: 100,
                        })}
                    />
                </Link>
            </div>
        </div>
    );
};
